export default __webpack_public_path__ + "static/media/g2022-21.4a135490.jpeg";